// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37Sox","rootMobile":"styles_rootMobile__2pU8D"};